module.exports = __webpack_public_path__ + "img/GA.4d72c8b6.svg";